<template>
  <modal
    v-slot="{ data }"
    name="editFavoriteOrder"
    modal-style="compact"
  >
    <edit-favorite-order
      :order="data.order"
      :refresh="data.refresh"
      @save="(event) => {
        if (data.onSave) {
          data.onSave(event);
        }
      }"
    />
  </modal>
</template>


<script>
  import EditFavoriteOrder from './edit-favorite-order/index.vue';

  export default {
    name: 'EditFavoriteOrderModal',

    components: {
      EditFavoriteOrder
    }
  };
</script>
